module.exports = __webpack_public_path__ + "media/images/ru-d75043fa4d426adc7a0f6d4a9c76852f.png";